// PDF Download Handler
const downloadPDF = (url, filename) => {
  return new Promise((resolve, reject) => {
    try {
      // Method 1: Using Fetch API
      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = blobUrl;
          a.download = filename || 'meraki_orden.pdf';
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(blobUrl);
          resolve(true);
        })
        .catch(error => {
          console.error('Error downloading PDF with fetch:', error);
          
          // Method 2: Fallback to window.open
          const newWindow = window.open(url, '_blank');
          if (newWindow) {
            setTimeout(() => {
              newWindow.close();
              resolve(true);
            }, 1000);
          } else {
            // Method 3: Last resort - direct link
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.download = filename || 'meraki_orden.pdf';
            link.click();
            resolve(true);
          }
        });
    } catch (error) {
      console.error('Error in PDF download:', error);
      reject(error);
    }
  });
};

export { downloadPDF }; 